/**
 * @generated SignedSource<<551d57d654a5c092cb6bd1b3897e2951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingSidebarContainer_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingEntrypointProvider_view">;
  readonly " $fragmentType": "ConditionalFormattingSidebarContainer_view";
};
export type ConditionalFormattingSidebarContainer_view$key = {
  readonly " $data"?: ConditionalFormattingSidebarContainer_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarContainer_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "ConditionalFormattingSidebarContainer_view",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ConditionalFormattingEntrypointProvider_view"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "3cc3ce39bcd2f953168d8cbd0ff16fef";

export default node;
